// src/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from 'firebase/auth';



const firebaseConfig = {
  apiKey: "AIzaSyA_zAIk1Ik8Kc2eWJcIDcWQ9Kv-Yx5npVE",
  authDomain: "vipencuentros.com",
  projectId: "web-servicios-b2a91",
  storageBucket: "web-servicios-b2a91.firebasestorage.app",
  messagingSenderId: "361779942221",
  appId: "1:361779942221:web:266c636c61a3cf9c4ddd04",
  measurementId: "G-7QV0P82DJC"
};


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

// Explicitly set persistence to LOCAL
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    // Persistence set
  })
  .catch((error) => {
    console.error("Error setting persistence:", error);
  });

const provider = new GoogleAuthProvider();

export { db, storage, auth, provider };
